import script from "./AppAIChatSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./AppAIChatSidebar.vue?vue&type=script&setup=true&lang=js"

import "./AppAIChatSidebar.vue?vue&type=style&index=0&id=334da526&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-334da526"]])

export default __exports__